var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['loadingModal-circular', { 'is-turning': _vm.turning }]})
}
var staticRenderFns = []

export { render, staticRenderFns }